import { apiFetch } from './client.js';

/**
 * The History of a settings section (DEV-133, DEV-137): one endpoint for all
 * of them, read-only. Each section names itself; integrations also name the
 * vendor.
 */

export type SettingsHistorySubject =
  | 'CURRENCIES'
  | 'INTEGRATION'
  | 'MONITORING_RULES'
  | 'ALERT_ROUTING'
  | 'RISK_SCORING'
  | 'ONBOARDING_POLICY'
  | 'ADMIN_USERS'
  | 'ORGANISATION'
  // Settings → Treasury, per provider (DEV-139).
  | 'TREASURY';

/** A recorded settings change: who, when, why, and what changed (secrets by name only). */
export interface SettingsHistoryEntry {
  id: string;
  at: string;
  by: string;
  subjectId: string | null;
  outcome: string;
  reason: string;
  summary: string;
  changes: Array<{ key: string; label: string; before: unknown; after: unknown }>;
  secretsChanged: string[];
  /** DEV-142: the stored version this entry left in place; "Restore this version" names it. */
  restoreTarget?: string;
  /** DEV-142: this change restored that earlier version. */
  restoredFrom?: string;
}

export const settingsHistoryApi = {
  list: (subject: SettingsHistorySubject, subjectId?: string): Promise<SettingsHistoryEntry[]> => {
    const query = new URLSearchParams({ subjectType: subject, ...(subjectId === undefined ? {} : { subjectId }) });
    return apiFetch(`/admin/settings/history?${query.toString()}`);
  },
};

/** The react-query key of one section's History, so a save can refresh it. */
export const settingsHistoryKey = (subject: SettingsHistorySubject, subjectId?: string): readonly unknown[] =>
  subjectId === undefined ? ['settings-history', subject] : ['settings-history', subject, subjectId];
